import React, {useEffect} from 'react';

import {hooks} from '../../hooks';
import {components} from '../../components';
import {actions} from '../../store/actions';
import {salon, salonServices} from '../../config/salon';

export const Categories: React.FC = () => {
  const dispatch = hooks.useDispatch();

  hooks.useThemeColor('#FFF7F4');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#FFF7F4'));
  }, [dispatch]);

  return (
    <>
      <components.Header
        title='Hizmetler'
        showLogo={true}
        showBasket={true}
        headerStyle={{backgroundColor: 'var(--main-background)'}}
      />
      <main className='scrollable salon-main salon-main--quiet'>
        <components.HeroSlider />
        <section className='salon-section'>
          <div className='salon-section__header'>
            <div>
              <span className='salon-eyebrow signature-text'>
                {salon.tagline}
              </span>
              <h2>Hizmet Menüsü</h2>
              <p className='salon-section__text'>
                Çağla Karagiray
                <span className='signature-text signature-text--inline'>
                  The Most Beauty
                </span>
                'de sunulan bakım ve güzellik işlemleri.
              </p>
            </div>
          </div>
          <components.ServiceGrid
            services={salonServices}
            className='service-grid--full'
          />
        </section>
      </main>
      <components.QuickContact />
      <components.Footer />
    </>
  );
};
